<template>
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 280.02 236.33" style="enable-background:new 0 0 280.02 236.33;" xml:space="preserve">
    <g>
        <path :style="defineStroke" class="st0" d="M57.96,140.93l-11.4,61.56c-2.64,14.29,8.32,27.47,22.85,27.47h11.1c8.98,0,17.15-5.17,21-13.28l7.4-15.61
            c3.85-8.11,12.02-13.28,21-13.28h8.17c8.98,0,17.15,5.17,21,13.28l7.4,15.61c3.85,8.11,12.02,13.28,21,13.28h11.1
            c14.53,0,25.49-13.18,22.85-27.47l-11.4-61.56c-2.04-11.02-11.65-19.01-22.85-19.01H80.81C69.6,121.92,60,129.92,57.96,140.93z"/>
        <path :style="defineStroke" class="st1" d="M106.97,154.45h-6.48v-6.48c0-4.63-3.76-8.39-8.39-8.39h0c-4.64,0-8.39,3.76-8.39,8.39v6.48h-6.48
            c-4.64,0-8.39,3.76-8.39,8.39s3.76,8.39,8.39,8.39h6.48v6.48c0,4.63,3.76,8.39,8.39,8.39h0c4.64,0,8.39-3.76,8.39-8.39v-6.48h6.48
            c4.64,0,8.39-3.76,8.39-8.39S111.61,154.45,106.97,154.45z"/>
        <circle :style="defineStroke" class="st2" cx="174.39" cy="145.52" r="8.03"/>
        <circle :style="defineStroke" class="st2" cx="191.67" cy="162.81" r="8.03"/>
        <circle :style="defineStroke" class="st2" cx="157.2" cy="162.71" r="8.03"/>
        <circle :style="defineStroke" class="st2" cx="174.49" cy="179.99" r="8.03"/>
    </g>
    <g>
        <path :style="defineStroke" class="st0" d="M211.6,154.68l5.87,12.38c3.85,8.11,12.02,13.28,21,13.28h11.1c14.53,0,25.49-13.18,22.85-27.47l-11.4-61.56
            c-2.04-11.02-11.65-19.01-22.85-19.01H131.81c-11.2,0-20.81,7.99-22.85,19.01l-4.59,30.61"/>
        <path :style="defineStroke" class="st1" d="M151.49,121.61h6.48c4.64,0,8.39-3.76,8.39-8.39s-3.76-8.39-8.39-8.39h-6.48v-6.48c0-4.63-3.76-8.39-8.39-8.39
            h0c-4.64,0-8.39,3.76-8.39,8.39v6.48h-6.48c-4.64,0-8.39,3.76-8.39,8.39s3.76,8.39,8.39,8.39h6.48"/>
        <circle :style="defineStroke" class="st2" cx="225.39" cy="95.9" r="8.03"/>
        <circle :style="defineStroke" class="st2" cx="242.67" cy="113.19" r="8.03"/>
        <circle :style="defineStroke" class="st2" cx="208.2" cy="113.09" r="8.03"/>
        <circle :style="defineStroke" class="st2" cx="225.49" cy="130.37" r="8.03"/>
    </g>
    <g>
        <path :style="defineStroke" class="st0" d="M170.14,73.95c-2.04-11.02-11.35-17.65-22.55-17.65H41.22c-11.2,0-20.81,7.99-22.85,19.01l-11.4,61.56
            c-2.64,14.29,8.32,27.47,22.85,27.47h22.69"/>
        <path :style="defineStroke" class="st1" d="M67.39,88.83H60.9v-6.48c0-4.63-3.76-8.39-8.39-8.39h0c-4.64,0-8.39,3.76-8.39,8.39v6.48h-6.48
            c-4.64,0-8.39,3.76-8.39,8.39s3.76,8.39,8.39,8.39h6.48v6.48c0,4.63,3.76,8.39,8.39,8.39h0c4.64,0,8.39-3.76,8.39-8.39v-6.48h6.48
            c4.64,0,8.39-3.76,8.39-8.39S72.02,88.83,67.39,88.83z"/>
    </g>
    <g>
        <path :style="defineStroke" class="st0" d="M223.72,72.3l-8.51-45.99c-2.04-11.02-11.65-19.01-22.85-19.01H85.99c-11.2,0-20.81,7.99-22.85,19.01
            L57.59,56.3"/>
        <path :style="defineStroke" class="st1" d="M105.68,56.62h6.48c4.64,0,8.39-3.76,8.39-8.39s-3.76-8.39-8.39-8.39h-6.48v-6.48c0-4.63-3.76-8.39-8.39-8.39
            h0c-4.64,0-8.39,3.76-8.39,8.39v6.48h-6.48c-4.64,0-8.39,3.76-8.39,8.39s3.76,8.39,8.39,8.39h6.48"/>
        <circle :style="defineStroke" class="st2" cx="179.57" cy="30.91" r="8.03"/>
        <circle :style="defineStroke" class="st2" cx="196.86" cy="48.19" r="8.03"/>
        <circle :style="defineStroke" class="st2" cx="162.38" cy="48.1" r="8.03"/>
        <circle :style="defineStroke" class="st2" cx="179.67" cy="65.38" r="8.03"/>
    </g>
    </svg>
</template>

<script>
import { addAlpha } from '../../../../../helpers/custom'
export default {
    data:() => ({colors: ''}),
    props:{
        status: {
            require: false,
            type: String
        }
    },
    created(){
        // console.log("STATUS: ", this.status)
        this.colors = JSON.parse(localStorage.getItem('colors'))
    },
    computed:{
        defineStroke(){
            if(this.status == 'disabled' || this.status == 'finished' || this.status == 'expired') return {'stroke': '#bfbfbf'}
            if(this.status == 'scheduled-game') return {'stroke': addAlpha( "#ffffff", 0.5)}
            if(this.status == 'started-game') return {'stroke': "#ffffff"}
        },
    }
}
</script>

<style scoped>
    .st0{fill:none;stroke-width:8;stroke-miterlimit:10;}
    .st1{fill:none;stroke-width:6;stroke-miterlimit:10;}
    .st2{fill:none;stroke-width:5;stroke-miterlimit:10;}
</style>
